/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { rootAppPath } from './utils';
import ReportsList from '@apps/company-tracker/components/reports-list';
import { Switch, Route } from 'react-router-dom';
import { CompanyTrackerSurveyRoute } from './CompanyTrackerSurveyRoute';
import { AssuranceModal } from '@features/assurance/assurance-modal';
import { reloadSurveyListSummary } from '@actions/survey';
import { SurveyAddAssurance } from '@g17eco/types/survey';
import { RootSwitcherContext } from '../OrganizationSwitcherRoute';
import { useAppDispatch, useAppSelector } from '@reducers/index';
import { SettingStorage } from '@services/SettingStorage';
import { SurveyConfiguration } from '@features/survey-configuration/SurveyConfiguration';
import Dashboard from '@g17eco/molecules/dashboard';
import { CreateCombinedReportRoute } from '@apps/company-tracker/routes/CreateCombinedReportRoute';
import { ROUTES } from '../../constants/routes';

interface AssuranceModalState {
  isOpen: boolean;
  surveyId: string;
  initiativeId: string;
}

export function ReportingRoute() {

  const [assuranceModal, setAssuranceModal] = useState<AssuranceModalState>({
    isOpen: false,
    surveyId: '',
    initiativeId: '',
  });
  const { data: rootInitiatives } = useAppSelector((state) => state.rootInitiatives);
  const { routeMatcher } = React.useContext(RootSwitcherContext)

  // @TODO should clean up once root org is improved
  let selectedId: string | undefined;
  if (routeMatcher) {
    const organizations = routeMatcher.filterInitiatives(rootInitiatives)
    selectedId = organizations.length === 1 ? organizations[0]?._id : SettingStorage.getItem(routeMatcher.storageKey);
  }

  const dispatch = useAppDispatch();

  const handleAddAssurance = (survey: SurveyAddAssurance) => {
    setAssuranceModal((am) => ({
      ...am,
      isOpen: true,
      surveyId: survey._id,
      initiativeId: survey.initiativeId,
    }));
  }

  const toggleAssurance = (submitted?: boolean) => {
    setAssuranceModal((am) => ({ ...am, isOpen: !am.isOpen }));
    if (submitted === true) {
      dispatch(reloadSurveyListSummary());
    }
  };

  // Match survey or fallback to list view
  return <>
    <Switch>
      <Route path={`/${rootAppPath}/reports/:initiativeId/create-combined`}>
        <CreateCombinedReportRoute />
      </Route>
      <Route path={`/${rootAppPath}/reports/:initiativeId/:surveyId/update-combined`}>
        <CreateCombinedReportRoute />
      </Route>
      <Route path={`/${rootAppPath}/reports/:initiativeId/create`}>
        <Dashboard>
          <SurveyConfiguration />
        </Dashboard>
      </Route>

      <Route path={[
        ROUTES.COMPANY_TRACKER_SURVEY_AI_AUTO_ANSWER.path,
        ROUTES.COMPANY_TRACKER_SURVEY.path
      ]} >
        <CompanyTrackerSurveyRoute handleAddAssurance={handleAddAssurance} />
      </Route>

      <Route>
        <ReportsList organizationId={selectedId} handleAddAssurance={handleAddAssurance} />
      </Route>
    </Switch>
    {assuranceModal.isOpen && <AssuranceModal toggle={toggleAssurance} {...assuranceModal} />}
  </>
}
